// extracted by mini-css-extract-plugin
export var redoItem = "_pr-1";
export var redoTrigger = "_pr-0";